
require('lodash')


export const Auth = {
  checkValidity: checkValidity,
  isAuthed: isAuthed,
  payload: payload,
  parseJwt: parseJwt,
  saveToken: saveToken,
  getToken: getToken,
  isTokenFresh: isTokenFresh,
  logout: logout,
  login: login,
  getBackendUrl:getBackendUrl,
  getUserRole: getUserRole,
  goLogin: goLogin

}

function getToken () {
  let data = window.localStorage[process.env.VUE_APP_AUTH_TOKEN]
  if (data && data !== {}) {
    return JSON.parse(data)
  }
  return false
}

function isAuthed () {
  let parsedToken = parseJwt(getToken())
  return (parsedToken && isTokenFresh(parsedToken))
}

function parseJwt (token) {
  if (_.isEmpty(token)) {
    return false
  }
  try {
    return payload(token)
  } catch (e) {
    console.error('Invalid Token Session', 'JWT error ' + e.message)
    return false
  }
}

function isTokenFresh (parsedToken) {
  if (parsedToken) {
    var isAuthed = (Math.round(new Date().getTime() / 1000) <= parsedToken.exp)
    if (isAuthed) {
      /* setTimeout(function () {
        this.checkValidity()
      }.bind(this), 50000) */
    }
    return isAuthed
  } else {
    return false
  }
}

function payload (token) {
  let base64UrlList = token.split('.')
  if (base64UrlList.length < 2) {
    return false
  }
  let base64Url = base64UrlList[1]
  let base64 = base64Url.replace('-', '+').replace('_', '/')

  return JSON.parse(window.atob(base64))
}

function checkValidity () {
  if (!isAuthed()) {
    window.location.reload()
  } else {
    setTimeout(function () {
      this.checkValidity()
    }.bind(this), 5000)
  }
}
function logout () {
  window.localStorage.removeItem(process.env.VUE_APP_AUTH_TOKEN)
}

function saveFullToken (token) {
  if (token) {
    window.localStorage.setItem(process.env.VUE_APP_AUTH_TOKEN, JSON.stringify(token))
    const expireAt = moment().add(token.expires_in - 30, 'seconds')
    window.localStorage.setItem(process.env.VUE_APP_EXP_TOKEN, expireAt.valueOf())
  }
}

function saveToken (token) {
  if (token) {
    window.localStorage.setItem(process.env.VUE_APP_AUTH_TOKEN, JSON.stringify(token))
  }
}

function encodeDataToURL (data) {
  return Object
    .keys(data)
    .map(value => `${value}=${encodeURIComponent(data[value])}`)
    .join('&')
}

function goLogin() {
  logout()
  let params = {redirect_uri: window.location.href,
    client_id: process.env.VUE_APP_AIO_CONNECT_CLIENT_ID,
    response_type: 'id_token',
    nonce: 'waluigithewinner'}
  window.location = process.env.VUE_APP_AIO_CONNECT_URL + 'auth?' + encodeDataToURL(params)
}

function login (token) {
  let payload = parseJwt(token)
  if ( !payload || _.isEmpty(payload)) {
    return false
  } else {
    saveToken(token)
    return payload
  }
}

function getBackendUrl () {
    if (parseJwt(getToken()).data !== undefined) {
      return parseJwt(getToken()).data.backend_url
    }
    return ''
}

function getUserRole () {
  const token = parseJwt(getToken())
  if (_.isEmpty(token) || _.isEmpty(token.resource_access)) {
    return []
  }
  return token.resource_access.kanban.roles
}

export default logout



// WEBPACK FOOTER //
// ./src/core/utils/auth.js